import { Button } from '@predoc/cow';
import { cn } from '@/lib/utils';
import type { FacesheetOutlineItem } from './types';

interface FacesheetOutlineItemsProps {
  items: FacesheetOutlineItem[];
  activeAnchorId?: string;
  onSelectItem: (anchorId: string) => void;
  depth?: number;
}

export const FacesheetOutlineItems = ({
  items,
  activeAnchorId,
  onSelectItem,
  depth = 0,
}: FacesheetOutlineItemsProps) => {
  return (
    <>
      {items.map((item) => {
        const isActive = activeAnchorId === item.anchorId;

        return (
          <div key={item.id} className="flex flex-col gap-1">
            <Button
              type="button"
              variant="ghost"
              onClick={() => onSelectItem(item.anchorId)}
              aria-current={isActive ? 'true' : undefined}
              className={cn(
                'h-auto w-full justify-start rounded py-1.5 text-left text-sm transition-colors aria-[current=true]:bg-white aria-[current=true]:text-gray-900 aria-[current=true]:shadow-sm',
                depth === 0 ? 'px-3 font-semibold' : 'px-3 pl-6 font-normal',
                isActive
                  ? 'bg-white text-gray-900 shadow-sm hover:bg-white hover:text-gray-900'
                  : 'text-gray-700 hover:bg-white/60 hover:text-gray-900',
              )}
            >
              {item.label}
            </Button>

            {item.children?.length ? (
              <FacesheetOutlineItems
                items={item.children}
                activeAnchorId={activeAnchorId}
                onSelectItem={onSelectItem}
                depth={depth + 1}
              />
            ) : null}
          </div>
        );
      })}
    </>
  );
};
